import React from "react";
import './Breadcrumb.css';

function Breadcrumb()
{
    return(
            <div className="comb-sec breadcrumb-sec">
             <div className="container-fluid px-4">
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0">
                <li className="breadcrumb-item"><a href="#">Home</a>
                </li>
                <li className="breadcrumb-item"><span>Page Name</span>
                </li>
                <li className="breadcrumb-item active"><span>Page Name</span>
                </li>
            </ol>
        </nav>
    </div>
                    </div>
    );
}
export default Breadcrumb;